// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"lI-z","smallCardRow":"mI-z","largeCardRow":"nI-z","productSearchRow":"oI-z","curatedRow":"pI-z"};